$(document).ready(function () {
	
  /*_____ Slick Static Features Slider _____*/
  $("#slick-seen").slick({
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      pauseOnHover: true,
      cssEase: 'linear',
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 576,
              settings: {
                  slidesToShow: 1,
                  centerMode: true,
              },
          },
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 2,
              },
          },
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 3,
              },
          }
      ],
  });

  function features_tabs() {
    $("#features .list > li:nth-child(1) .in").addClass("active")
    let item_01 = $("#features .list > li:nth-child(1) .in strong").text()
    let imgsrc =  $("#features .list > li:nth-child(1) .in .main-img-hidden").attr('src');

    $("#features .image > strong").text(item_01)
    $("#features .image > img").attr("src",imgsrc)
                
    $(document).on("mouseenter", "#features .list > li .in", function () {
        $("#features .list > li .in").removeClass("active")
        $(this).addClass("active")
        let item = $(this).find("strong").text()
        $("#features .image > strong").text(item)
        let newimgsrc =  $(this).find(".main-img-hidden").attr('src');
        console.log(newimgsrc)
        $("#features .image img").attr("src", newimgsrc) 
    })
  }
  features_tabs()

  /*_____ Slick Slider _____*/
  $("#slick-review").slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 1,
              },
          },
      ],
  })
  $(".prev_btn").click(function () {
      $("#slick-review").slick("slickPrev")
  })
  $(".next_btn").click(function () {
      $("#slick-review").slick("slickNext")
  })
  $(".prev_btn").addClass("slick-disabled")
  $("#slick-review").on("afterChange", function () {
      if ($(".slick-prev").hasClass("slick-disabled")) {
          $(".prev_btn").addClass("slick-disabled")
      } else {
          $(".prev_btn").removeClass("slick-disabled")
      }
      if ($(".slick-next").hasClass("slick-disabled")) {
          $(".next_btn").addClass("slick-disabled")
      } else {
          $(".next_btn").removeClass("slick-disabled")
      }
  })

  /*_____ Video _____*/
  $(document).on("click", ".vid_blk .play-vid-1", function () {
      let sec = $(this).parents("section")
      sec.find(".video_popup").fadeIn()
      let src = sec.find(".video_popup iframe").attr("data-src")
      sec.find(".video_popup iframe").attr("src", src)
  })
  $(document).on("click", ".video_popup .crossBtn", function () {
      $(".video_popup iframe").attr("src", "")
      $(".video_popup").fadeOut()
  })
  $(document).on("click", ".vid_blk .play-vid-2", function () {
      let sec2 = $(this).parents("section")
      sec2.find(".video_popup-2").fadeIn()
      let src = sec2.find(".video_popup-2 iframe").attr("data-src")
      sec2.find(".video_popup-2 iframe").attr("src", src)
  })
  $(document).on("click", ".video_popup-2 .crossBtn", function () {
      $(".video_popup-2 iframe").attr("src", "")
      $(".video_popup-2").fadeOut()
  })

  $("#slick-seen-thumb").slick({
      dots: false,
      arrows: false,
      infinite: true,
      // centerMode: true,
      // centerPadding: 0,
      speed: 1000,
      focusOnSelect: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: "#slick-seen-content",
      responsive: [
          {
              breakpoint: 769,
              settings: {
                  slidesToShow: 3,
              },
          },
          {
              breakpoint: 580,
              settings: {
                  slidesToShow: 3,
              },
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 2,
              },
          },
      ],
  })
  $("#slick-seen-content").slick({
      dots: false,
      arrows: false,
      infinite: true,
      draggable: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: "#slick-seen",
  })
  /*_____ FAQ's _____*/
	$(document).on("click", ".faqBlk > h5", function () {
		$(".faqBlk").not($(this).parent().toggleClass("active")).removeClass("active")
		$(".faqBlk > .txt").not($(this).parent().children(".txt").slideToggle()).slideUp()
	})



  $("#slick-help").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      cssEase: 'linear',
      prevArrow:'<button class="slide-arrow prev-arrow"><i class="fal fa-long-arrow-left"></i></button>',
      nextArrow:'<button class="slide-arrow next-arrow"><i class="fal fa-long-arrow-right"></i></button>',
      slidesToShow: 7,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 1,
              },
          },
          {
              breakpoint: 576,
              settings: {
                  slidesToShow: 2,
              },
          },
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 3,
              },
          },
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 4,
              },
          },
          {
              breakpoint: 1199,
              settings: {
                  slidesToShow: 5,
              },
          }
      ],
  });
})
